import { memo } from "react";
import type { BatchJobPanelProps } from "../../batch_job_kind_contract";
import { DocumentIndexingRefreshPanelBody } from "./DocumentIndexingRefreshPanelBody";
import { useDocumentIndexingRefreshPanel } from "./useDocumentIndexingRefreshPanel";

/** Results panel for a document_indexing_refresh batch job. */
export const DocumentIndexingRefreshPanel = memo(function DocumentIndexingRefreshPanel({
  job,
}: BatchJobPanelProps) {
  const panel = useDocumentIndexingRefreshPanel(job);
  return <DocumentIndexingRefreshPanelBody panel={panel} />;
});
